import moment from 'moment';

/**
 * @param date string | Date
 * @returns Boolean if date is valid
 */
export const isDateValid = (date: Date | string) => {
  return moment(date).isValid();
};
